export const updateInvite = (invite) => ({
  model: "currentCampaign",
  type: "UPDATE_INVITE",
  data: { invite },
});
